/**
 * @generated SignedSource<<fb7eb0e39d01416285f51ba649c967fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SalesAssociatesModal_salesAssociatesConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly name: string | null;
      readonly avatar: {
        readonly url: string;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"SalesAssociatesModal_salesAssociate">;
    };
  }>;
  readonly " $fragmentType": "SalesAssociatesModal_salesAssociatesConnection";
};
export type SalesAssociatesModal_salesAssociatesConnection$key = {
  readonly " $data"?: SalesAssociatesModal_salesAssociatesConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"SalesAssociatesModal_salesAssociatesConnection">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SalesAssociatesModal_salesAssociatesConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SalesAssociateEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SalesAssociate",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Avatar",
              "kind": "LinkedField",
              "name": "avatar",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "SalesAssociatesModal_salesAssociate",
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SalesAssociatePasswordModal_salesAssociate"
                }
              ]
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SalesAssociateConnection",
  "abstractKey": null
};
})();

(node as any).hash = "b62c6d62359144d9637189a665b4077c";

export default node;
